// Import _remove from 'lodash/remove';

/**
 * @desc  SchoolClassService class.
 * @ngInject
 */
export default class SchoolClassService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;

    this.schoolClass = [];
    this.unassignedStudents = [];

    this.$rootScope.$on('scr.select', () => {
      this.unassignedStudents.splice(0, this.unassignedStudents.length);
    });
  }

  getSchoolClass() {
    if (this.schoolClass.length > 0) {
      return this.$q.resolve(this.schoolClass);
    }

    return this.$http({
      method: 'GET',
      url: '/SCR/schoolClass'
    }).then(result => {
      this.schoolClass = result.data.schoolClass;
      return this.schoolClass;
    }, err => this.$q.reject(err));
  }

  getStudents(schoolClassId, fromServer = false) {
    if (this.unassignedStudents.length > 0 && !fromServer) {
      return this.$q.resolve(this.unassignedStudents);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/schoolClass/${schoolClassId}/student`
    }).then(result => {
      this.unassignedStudents = result.data.students;
      return this.unassignedStudents;
    }, err => this.$q.reject(err));
  }
}
